module.exports = __webpack_public_path__ + "static/media/money-grey.d46666f5.svg";